<template>
  <div>
    <table class="w-100" border="0" align="center">
      <tr>
        <td class="background-app padding-ios" colspan="4" align="center" width="100%" height="40">
          RECOS ASIGNADAS
        </td>
      </tr>
      <tr class="header" bgcolor="#CCCCCC">
        <td align="center" height="30"><strong>ID Pago</strong></td>
        <td align="center" width="100"><strong>Fecha</strong></td>
        <td align="center"><strong>Tipo</strong></td>
        <td align="center"><strong>Llegada</strong></td>
      </tr>
      <tr
        class="font-14"
        :class="{ 'hightlight': !service.state }"
        style="border-bottom: 1px solid #ccc"
        v-for="service in services"
        :key="service.id_pay"
        @click="goToReco(service.id_pay)"
      >
        <td align="center" height="50" width="90">{{ service.id_pay }}</td>
        <td align="center" width="100">{{ formatDate(service.date) }}</td>
        <td align="center">{{ service.rtx_type }}</td>
        <td align="center">{{ formatHour(service.hour_end) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'RTX',
  data() {
    return {
      services: []
    }
  },
  created() {
    this.loadServices()
  },
  methods: {
    loadServices() {
      http.get('app/service/rtx/all')
        .then(res => {
          this.services = Object.values(res.body.services)
        })
        .catch(err => {
          console.error('Error loading RTX services:', err)
        })
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('es-CL')
    },
    formatHour(hour) {
      if (!hour) return ''
      // Si hour es un string de hora, devolverlo tal como está
      if (typeof hour === 'string') return hour
      // Si es un timestamp, convertirlo a formato de hora
      return new Date(hour).toLocaleTimeString('es-CL', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    goToReco(idPay) {
      this.$router.push(`/reco/${idPay}`)
    }
  }
}
</script>

<style>
.hightlight {
  background-color: #ff0 !important;
}

.font-14 {
  font-size: 14px;
}

tr {
  cursor: pointer;
}

tr:hover {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/pages/RTX.vue